(function () {
  if (window.em2HoverVideo) return;
  window.em2HoverVideo = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function video(zone) {
    return zone ? zone.querySelector('[data-em-hover-video]') : null;
  }

  function tryPlay(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function start(zone, force) {
    var v = video(zone);
    if (!v || (reduced.matches && !force)) return;
    v.dataset.emHover = '1';
    if (!v.getAttribute('src')) {
      v.preload = 'auto';
      v.setAttribute('src', v.getAttribute('data-src'));
    }
    tryPlay(v);
  }

  function stop(zone) {
    var v = video(zone);
    if (!v) return;
    v.dataset.emHover = '0';
    v.pause();
    try { v.currentTime = 0; } catch (err) {}
  }

  function media(e) {
    var t = e.target;
    return t && t.classList && t.classList.contains('em2-card__media') ? t : null;
  }

  document.addEventListener('pointerenter', function (e) { var z = media(e); if (z) start(z); }, true);
  document.addEventListener('pointerleave', function (e) { var z = media(e); if (z) stop(z); }, true);
  document.addEventListener('focusin', function (e) {
    var card = e.target.closest && e.target.closest('.em2-card');
    if (card) start(card.querySelector('.em2-card__media'));
  });
  document.addEventListener('focusout', function (e) {
    var card = e.target.closest && e.target.closest('.em2-card');
    if (card) stop(card.querySelector('.em2-card__media'));
  });
})();
